import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as css from "./person-detail-styles.module.css";
import EditAddRelationship from "./EditAddRelationship";
import AddRelationshipModal from "./modals/AddRelationshipModal";
import * as actions from "../actions/personDetailActionCreators";
import CollapsibleElement from "./CollapsibleElement";
import Loading from "../../Goals/components/Loader";

const RELATIONSHIP_OPTIONS = [
  { label: "Assistant", value: "assistant" },
  { label: "Boyfriend", value: "boyfriend" },
  { label: "Brother-in-law", value: "brother-in-law" },
  { label: "Brother", value: "brother" },
  { label: "Child-in-law", value: "child-in-law" },
  { label: "Child", value: "child" },
  { label: "Cousin", value: "cousin" },
  { label: "Coworker", value: "coworker" },
  { label: "Daughter", value: "daughter" },
  { label: "Employee", value: "employee" },
  { label: "Ex-spouse", value: "ex-spouse" },
  { label: "Family", value: "family" },
  { label: "Father", value: "father" },
  { label: "Fiance", value: "fiance" },
  { label: "Friend", value: "friend" },
  { label: "Girlfriend", value: "girlfriend" },
  { label: "Grandchild", value: "grandchild" },
  { label: "Grandparent", value: "grandparent" },
  { label: "Husband", value: "husband" },
  { label: "Landlord", value: "landlord" },
  { label: "Lender", value: "lender" },
  { label: "Mother", value: "mother" },
  { label: "Neighbor", value: "neighbor" },
  { label: "Other", value: "other" },
  { label: "Parent-in-law", value: "parent-in-law" },
  { label: "Parent", value: "parent" },
  { label: "Partner", value: "partner" },
  { label: "Referee", value: "referee" },
  { label: "Referrer", value: "referrer" },
  { label: "Roommate", value: "roommate" },
  { label: "Sibling", value: "sibling" },
  { label: "Sister-in-law", value: "sister-in-law" },
  { label: "Sister", value: "sister" },
  { label: "Son", value: "son" },
  { label: "Spouse", value: "spouse" },
  { label: "Stepchild", value: "step-child" },
  { label: "Stepparent", value: "step-parent" },
  { label: "Tenant", value: "tenant" },
  { label: "Wife", value: "wife" },
];

const Relationships = () => {
  const dispatch = useDispatch();
  const person = useSelector((state) => state.personDetail.person);
  const relationships = useSelector((state) => state.personDetail.relationships);
  const addRelationshipModalOpen = useSelector((state) => state.personDetail.addRelationshipModalOpen);

  useEffect(() => {
    if (!person.data?.id) return;
    dispatch(actions.fetchRelationships(person.data));
  }, [person.data?.id]);

  return (
    <CollapsibleElement
      id="pdp-relationships"
      title="Relationships"
      buttonText="+ ADD"
      buttonClickFunction={() => dispatch(actions.openAddRelationShipModal())}
    >
      {!person.data && <Loading />}
      <div id="person-relationships-card">
        {/* TODO: need to look at what happens when person isn't readable... see link_to_or_text in relationship_decorator.rb */}
        {relationships.length === 0 && (
          <div
            className={css.personDetailEmptyStateText}
            style={{ paddingLeft: "20px", paddingRight: "14px" }}
          >
            Use relationships to link contacts and show how contacts know each other.
          </div>
        )}
        <div className="tw-flex tw-flex-col tw-mx-[-20px]">
          {relationships.map((relationship) => (
            <EditAddRelationship
              key={relationship.id}
              relationship={relationship}
              relationshipOptions={RELATIONSHIP_OPTIONS}
              saveRelationship={(...args) => dispatch(actions.saveRelationship(...args))}
              deleteRelationship={(...args) => dispatch(actions.deleteRelationship(...args))}
              person={person}
            />
          ))}
        </div>
        {addRelationshipModalOpen && (
          <AddRelationshipModal
            closeAddRelationShipModal={() => dispatch(actions.closeAddRelationShipModal())}
            addRelationship={(...args) => dispatch(actions.addRelationship(...args))}
            person={person}
            relationshipOptions={RELATIONSHIP_OPTIONS}
            saveRelationship={(...args) => dispatch(actions.saveRelationship(...args))}
          />
        )}
      </div>
    </CollapsibleElement>
  );
};

export default Relationships;
